import { aPaymentPageReady, aSbsPremiumPurchaseBuyButtonPressed, checkOutPageViewTooltip, packagePickerCheckoutLoadFailedSrc17Evid728, packagePickerErrorSrc17Evid2236, platformizedPackagePickerCheckoutPageDoublePurchaseModalCloseSrc17Evid2250, premiumDoublePurchasePopupAction, premiumViewDoublePurchasePopup, rPremiumOrderPageSubmitPending, rPremiumOrderPageSubmitSuccess, rPremiumPurchaseError, rSbsOrderPagePremiumPurchaseBusinessError, rSbsOrderPagePremiumPurchaseFatalError, vPurchasePagePaymentSlipView, checkoutPageSwitchCycleComponentLoadSrc17Evid1079, checkoutPageSwitchCycleComponentClickSrc17Evid1080, checkoutPageItemExposedSrc17Evid1081 } from '@wix/bi-logger-premium-data/v2';
import { BiUtils, CycleUtils, getSearchParams } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../../components';
import { resolveSwitchPricing } from '../../components/Checkout/ChangePlanCycle/upsellPricing';
import { useCycleName } from '../useCycleName';
import { useBiLogger } from './useBiLogger';
import { useCommonBiEventsFields } from './useCommonBiEventsFields';
import { useInitGeneralBiEvents } from './useInitGeneralBiEvents';
export const useInitCheckoutPageBiEvents = () => {
  const [didInit, setDidInit] = React.useState(false);
  const module = useCurrentModule();
  const {
    setBiEvent
  } = module.SDK;
  const {
    biLogger
  } = useBiLogger();
  const selectedCycleId = module.SDK.PackagePickerStore.useSelectedCycleId();
  const cycle = CycleUtils.convertCycleIdToCycle(selectedCycleId) || undefined;
  const biCycle = BiUtils.getBiCycle(cycle);
  const cycleName = useCycleName({
    cycle,
    lowerCase: true
  });
  const productId = module.SDK.PackagePickerStore.useSelectedProductId();
  useInitGeneralBiEvents();
  const fetchProductQuery = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId: productId || ''
  });
  const {
    commonBiEventsFields,
    isLoading: isCommonBiEventsFieldsLoading
  } = useCommonBiEventsFields();
  const currencyQuery = module.SDK.eclipseOfferingApiClient.hooks.useFetchCurrency({});
  const checkoutSharedFields = {
    ...commonBiEventsFields,
    cycle: biCycle,
    productGuid: productId || undefined
  };
  const getPricingString = () => {
    var _fetchProductQuery$da, _pricing$catalogPrice, _pricing$finalPrice;
    const pricing = (_fetchProductQuery$da = fetchProductQuery.data) == null || (_fetchProductQuery$da = _fetchProductQuery$da.pricingDetails) == null ? void 0 : _fetchProductQuery$da.find(p => CycleUtils.isCycleEqual(p.cycle, cycle));
    return JSON.stringify({
      fullPrice: pricing == null || (_pricing$catalogPrice = pricing.catalogPrice) == null || (_pricing$catalogPrice = _pricing$catalogPrice.subtotal) == null ? void 0 : _pricing$catalogPrice.formattedAmount,
      priceAfterDiscount: pricing == null || (_pricing$finalPrice = pricing.finalPrice) == null || (_pricing$finalPrice = _pricing$finalPrice.subtotal) == null ? void 0 : _pricing$finalPrice.formattedAmount
    });
  };
  const getSwitchPricingString = targetCycleId => {
    var _fetchProductQuery$da2;
    return resolveSwitchPricing((_fetchProductQuery$da2 = fetchProductQuery.data) == null ? void 0 : _fetchProductQuery$da2.pricingDetails, targetCycleId);
  };
  const isLoading = isCommonBiEventsFieldsLoading || currencyQuery.isLoading || fetchProductQuery.isLoading;
  React.useEffect(() => {
    if (isLoading) {
      return;
    }
    setBiEvent('onCheckoutInitError', _ref => {
      let {
        failureReason,
        eventAggregator
      } = _ref;
      const additionalFields = {
        ...checkoutSharedFields,
        eventAggregator,
        failReason: failureReason
      };
      biLogger == null || biLogger.report(
      // 17:728
      packagePickerCheckoutLoadFailedSrc17Evid728({
        ...commonBiEventsFields,
        ...additionalFields
      }));
      const {
        debug
      } = getSearchParams();
      const errorAdditionalFields = {
        errorType: 'CheckoutInitError',
        errorMessage: failureReason,
        isDebug: debug
      };
      biLogger == null || biLogger.report(
      // 17:2236
      packagePickerErrorSrc17Evid2236({
        ...commonBiEventsFields,
        ...errorAdditionalFields
      }));
    });
    setBiEvent('onCheckoutValidationError', _ref2 => {
      let {
        failureReason,
        error,
        eventAggregator
      } = _ref2;
      const additionalFields = {
        ...checkoutSharedFields,
        eventAggregator,
        additionalInfo: error.message || failureReason
      };
      biLogger == null || biLogger.report(
      // 17:105
      rPremiumPurchaseError({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onCheckoutFatalError', _ref3 => {
      let {
        failureReason,
        error,
        eventAggregator
      } = _ref3;
      const additionalFields = {
        ...checkoutSharedFields,
        eventAggregator,
        additionalInfo: error.message || failureReason
      };
      biLogger == null || biLogger.report(
      // 17:177
      rSbsOrderPagePremiumPurchaseFatalError({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onCheckoutBusinessError', _ref4 => {
      let {
        failureReason,
        error,
        eventAggregator
      } = _ref4;
      const additionalFields = {
        ...checkoutSharedFields,
        eventAggregator,
        additionalInfo: error.message || failureReason
      };
      biLogger == null || biLogger.report(
      // 17:176
      rSbsOrderPagePremiumPurchaseBusinessError({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onCheckoutSubmitClick', _ref5 => {
      let {
        eventAggregator
      } = _ref5;
      const additionalFields = {
        eventAggregator
      };
      biLogger == null || biLogger.report(
      // 17:178
      aSbsPremiumPurchaseBuyButtonPressed({
        ...checkoutSharedFields,
        ...additionalFields
      }));
    });
    setBiEvent('onCheckoutPageLoad', () => {
      var _currencyQuery$data;
      const additionalFields = {
        pricing: getPricingString(),
        currency: (_currencyQuery$data = currencyQuery.data) == null ? void 0 : _currencyQuery$data.currency
      };
      biLogger == null || biLogger.report(
      // 17:942
      aPaymentPageReady({
        ...checkoutSharedFields,
        ...additionalFields
      }));
    });
    setBiEvent('onGoToSuccessPage', () => {
      biLogger == null || biLogger.report(
      // 17:3103
      rPremiumOrderPageSubmitSuccess({
        ...checkoutSharedFields
      }));
    });
    setBiEvent('onGoToSepaSuccessPage', () => {
      biLogger == null || biLogger.report(
      // 17:3104
      rPremiumOrderPageSubmitPending({
        ...checkoutSharedFields
      }));
    });
    setBiEvent('onGoToBoletoSuccessPage', () => {
      biLogger == null || biLogger.report(
      // 17:3202
      vPurchasePagePaymentSlipView({
        ...checkoutSharedFields
      }));
    });
    setBiEvent('onDoublePurchaseModalLoad', _ref6 => {
      let {
        reason
      } = _ref6;
      biLogger == null || biLogger.report(
      // 17:1220
      premiumViewDoublePurchasePopup({
        ...checkoutSharedFields,
        reason
      }));
    });
    setBiEvent('onDoublePurchaseModalClose', () => {
      biLogger == null || biLogger.report(
      // 17:2250
      platformizedPackagePickerCheckoutPageDoublePurchaseModalCloseSrc17Evid2250({
        ...checkoutSharedFields
      }));
    });
    setBiEvent('onDoublePurchaseModalClick', _ref7 => {
      let {
        reason
      } = _ref7;
      biLogger == null || biLogger.report(
      // 17:1221
      premiumDoublePurchasePopupAction({
        ...checkoutSharedFields,
        reason
      }));
    });
    setBiEvent('onCreditTooltipHover', () => {
      biLogger == null || biLogger.report(
      // 17:189
      checkOutPageViewTooltip({
        ...checkoutSharedFields,
        tooltipName: 'how-credit-calculated-tooltip'
      }));
    });
    setBiEvent('onSummaryBenefitsTooltipHover', () => {
      biLogger == null || biLogger.report(
      // 17:189
      checkOutPageViewTooltip({
        ...checkoutSharedFields,
        tooltipName: 'summary-benefits-savings-tooltip'
      }));
    });
    setBiEvent('onSwitchCycleComponentLoad', _ref8 => {
      var _currencyQuery$data2;
      let {
        componentName,
        targetCycle
      } = _ref8;
      biLogger == null || biLogger.report(
      // 17:1079
      checkoutPageSwitchCycleComponentLoadSrc17Evid1079({
        ...checkoutSharedFields,
        cycleid: biCycle,
        currency: (_currencyQuery$data2 = currencyQuery.data) == null ? void 0 : _currencyQuery$data2.currency,
        pricing: getPricingString(),
        componentName,
        switch_pricing: getSwitchPricingString(targetCycle)
      }));
    });
    setBiEvent('onSwitchCycleComponentClick', _ref9 => {
      var _currencyQuery$data3;
      let {
        targetCycle,
        componentName
      } = _ref9;
      biLogger == null || biLogger.report(
      // 17:1080
      checkoutPageSwitchCycleComponentClickSrc17Evid1080({
        ...checkoutSharedFields,
        cycleid: biCycle,
        currency: (_currencyQuery$data3 = currencyQuery.data) == null ? void 0 : _currencyQuery$data3.currency,
        pricing: getPricingString(),
        componentName,
        switch_pricing: getSwitchPricingString(targetCycle),
        cycle_id_after: targetCycle
      }));
    });
    setBiEvent('onPaymentButtonExposed', () => {
      var _fetchProductQuery$da3, _fetchProductQuery$da4;
      biLogger == null || biLogger.report(
      // 17:1081
      checkoutPageItemExposedSrc17Evid1081({
        ...checkoutSharedFields,
        cycleid: biCycle,
        cycleName,
        paymentCycle: CycleUtils.convertToBillingPaymentCycle(cycle),
        item_name: 'Submit Purchase',
        productFamilyGuid: (_fetchProductQuery$da3 = fetchProductQuery.data) == null ? void 0 : _fetchProductQuery$da3.productFamilyId,
        productFamily: (_fetchProductQuery$da4 = fetchProductQuery.data) == null ? void 0 : _fetchProductQuery$da4.name,
        isInitialPurchase: commonBiEventsFields.newPurchase === 'true'
      }));
    });
    setDidInit(true);
  }, [setBiEvent, biLogger, isLoading, commonBiEventsFields, checkoutSharedFields, currencyQuery.data]);
  return {
    didInit
  };
};
//# sourceMappingURL=useInitCheckoutPageBiEvents.js.map